import DataMesControlled from "../DataMesControlled"
import BarraBuscaComTodasUnidades from "../BarraBuscaComTodasUnidades"
import SelectMetricaIndicadorControlled from "../SelectMetricaIndicadorControlled"
import BarraBuscaControlled from "../BarraBuscaControlled";

function IndicadorBuscaFiltros({
    metricaCodigo, metricaOnChange,
    mesReferencia, mesReferenciaOnChange,
    estabelecimento, estabelecimentoOnChange
}) {

    console.log('### INICIANDO IndicadorBuscaFiltros ###');

    return (
        <div className='d-flex flex-column gap-3'>
            <div className='d-flex flex-md-row flex-column row gap-3'>
                <div className='col-12 col-sm-3'>
                    <label className='text-nowrap' htmlFor='mes-competencia'>Mês de Competência</label>
                    <DataMesControlled
                        value={mesReferencia}
                        onChange={(v) => mesReferenciaOnChange(v)}
                        getUltimoDia={false}
                    />
                </div>
                <div className='col-12 col-sm-8'>
                    <label className='text-nowrap' htmlFor='select-metrica-indicador'>Indicador</label>
                    <SelectMetricaIndicadorControlled
                        id='select-metrica-indicador'
                        value={metricaCodigo}
                        onChange={(v) => metricaOnChange(v)}
                    />
                </div>
            </div>
            <div>
                <label className='text-nowrap' htmlFor='barra-busca-unidade'>Unidade</label>
                <BarraBuscaControlled
                    id='barra-busca-unidade'
                    estabelecimento={estabelecimento}
                    onChange={
                        (v) => estabelecimentoOnChange(v)
                    }
                    estabelecimentosVigentes={false}
                    apenasQueEnviamRelatorio={false}
                />
            </div>
        </div>
    )
}

export default IndicadorBuscaFiltros